<div class="c-form__item u-layout-auto">
  <div class="rights">
    <div class="u-layout-flex">
      <div class="rights__title u-border-right">
        <h6>{{ titles.deselected }}</h6>
        <a
          (click)="moveItems(DESELECTED)"
          i18n="Label|Label for Enabling All items @@labelEnableAll"
          >Enable All</a
        >
      </div>
      <i class="fa fa-exchange rights__exchange" aria-hidden="true"></i>
      <div class="rights__title">
        <h6>{{ titles.selected }}</h6>
        <a
          (click)="moveItems(SELECTED)"
          i18n="Label|Label for Disabling All items @@labelDisableAll"
          >Disable All</a
        >
      </div>
    </div>
    <div class="u-layout-flex">
      <div class="right__items u-border-right">
        <div
          class="right__item"
          *ngFor="let item of getData(items, selectedValues, false)"
          (click)="moveItem(item, DESELECTED)"
          [ngClass]="{ disabled: item.value.disabled }"
        >
          <p>{{ item.value.title }}</p>
          <i class="fa fa-info-circle" aria-hidden="true" ls-tooltip>
            <ls-tooltip [position]="tooltipPosition" [color]="tooltipColor"
              >{{ item.value.description }}
            </ls-tooltip>
          </i>
        </div>
      </div>
      <div class="right__items">
        <div
          *ngFor="let item of getData(items, selectedValues, true)"
          class="right__item {{ item.value.class }}"
          (click)="moveItem(item, SELECTED)"
          [ngClass]="{ disabled: item.value.disabled }"
        >
          <p>{{ item.value.title }}</p>
          <i class="fa fa-info-circle" aria-hidden="true" ls-tooltip>
            <ls-tooltip [position]="tooltipPosition" [color]="tooltipColor"
              >{{ item.value.description }}
            </ls-tooltip>
          </i>
        </div>
      </div>
    </div>
    <div class="rights__legend" *ngIf="legendItems">
      <div class="rights__legend--item" *ngFor="let item of legendItems">
        <p>{{ item.name }}</p>
        <div class="right__item {{ item.value }}"></div>
      </div>
    </div>
  </div>
</div>
